"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.js = exports.css = void 0;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * 创建script
 * @param {string|object}   url       链接地址
 * @param {function}        callback  处理函数
 */
var js = function js(url, callback) {
  if (typeof window === 'undefined') {
    return false;
  }

  var script = document.createElement('script');
  var head = document.getElementsByTagName('head')[0];
  var loaded;

  if (_typeof(url) === 'object') {
    // eslint-disable-next-line
    for (var key in url) {
      script.setAttribute(key, url[key]);
    }
  } else {
    script.src = url;
  }
  /* eslint-disable no-multi-assign */


  if (typeof callback === 'function') {
    script.onload = script.onreadystatechange = function () {
      if (!loaded && (!script.readyState || /loaded|complete/.test(script.readyState))) {
        script.onload = script.onreadystatechange = null;
        loaded = true;
        callback();
      }
    };
  }
  /* eslint-enable no-multi-assign */


  head.appendChild(script);
};
/**
 * 创建css
 * @param {string}   url       链接地址
 */


exports.js = js;

var css = function css(url) {
  if (typeof window === 'undefined') {
    return false;
  }

  var head = document.getElementsByTagName('head')[0];
  var link = document.createElement('link');
  link.type = 'text/css';
  link.rel = 'stylesheet';
  link.href = url;
  head.appendChild(link);
};

exports.css = css;